<template>
  <div class="coupon">
    <span class="integral">{{$t('other.w82').replace('{%}',assets.IntegralCount)}}</span>
    <CouponModal :coupondata="couponMsg" ref='couponmodal'></CouponModal>
    <div class="couponBox">
      <Row class="cardmain">
        <div v-show="exchangeList.length==0" class="tip">{{$t('msg.m115')}}</div>
        <Col span="8" v-for="(v,i) in exchangeList" :key="i" :style="{marginBottom:'50px'}">
          <div class="cardcontent" :class="{cardbg:v.Type==0}">
            <div class="num">
              <div class="discount" :class="{disable:v.Type==0}">
                <span :class="[v.Rate == 0 ? sym : percent]">{{v.Rate == 0 ? '￥' : '%'}}</span>
                {{v.Rate== 0 ? v.Amount : v.Rate}}
              </div>
              <div class="rule">
                <p :class="{disable:v.Type==0}">{{v.TypeName}}</p>
                <p :class="{disable:v.Type==0}" v-show="v.Type==3">{{$t('other.w83').replace('{%}',v.InvestAmount)}}</p>
              </div>
            </div>
            <div class="desc">
              <p>{{$t('label.w127')}}：{{v.Days}}{{$t('label.w15')}}</p>
              <p>{{v.Description}}</p>
            </div>
          </div>
          <div class="bottom">
            <div class="bottom-l">
              <p>
                <span :class="{gray:v.Type==0}">{{v.NeedIntegralCount}}</span>
                <span :class="{gray:v.Type==0}">{{$t('label.w128')}}</span>
                <!-- <span :class="{gray:v.Type==0}">{{v.LastNeedIntegralCount}}{{$t('label.w128')}}</span> -->
              </p>
              <p :class="{gray:v.Type==0}">{{$t('other.w84').replace('{%}',v.RemainCount)}}</p>
            </div>
            <div class="bottom-r">
              <Button
                @click="getCoupon(v)"
                :disabled="v.RemainCount == 0"
                :class="{dis:v.RemainCount == 0}"
              >{{v.RemainCount==0?$t('btn.b61'):$t('btn.b62')}}</Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <div class="list">
      <h3>{{$t('title.w43')}}</h3>
      <Datatable
        url="/Member/RZJProfile/IntegralRecordList"
        field="IntegralRecordList"
        :th="[$t('label.w129'),$t('label.w128'),$t('label.w130'),$t('label.w131')]"
        :tip="$t('msg.m116')"
      >
        <template v-slot="{item}">
          <tr class="record">
            <td width="30%">{{item.IntegralTypeName}}</td>
            <td
              width="25%"
              :class="{purple:item.InOut==2}"
            >{{item.InOut==2?'-':'+'}}&nbsp;{{item.IntegralCount}}</td>
            <td width="25%">{{item.TotalIntegralCount}}</td>
            <td width="20%">{{item.CreatedAt}}</td>
          </tr>
        </template>
      </Datatable>
    </div>
  </div>
</template>

<script>
import Datatable from "../../components/datatable";
import CouponModal from "./couponModal";
export default {
  components: { Datatable, CouponModal },
  data() {
    return {
      sym: "sym",
      percent: "percent",
      exchangeList: [],
      couponMsg: []
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$axios
        .get("/Member/RZJProfile/CouponExchangeConfigList")
        .then(res => {
          if (res.err) return res.throw();
          this.exchangeList = res;
        });
    },
    getCoupon(v) {
      this.$refs.couponmodal.modal = true;
      this.couponMsg = v;
    }
  },
  computed:{
    assets(){
      return this.$store.state.user.assets
    }
  }
};
</script>
<style scoped lang='less'>
.coupon {
  height: 100%;
  width: 100%;
  background: #f1f2f5;
  position: relative;
  .integral {
    font-size: 14px;
    font-weight: 500;
    color: rgba(106, 152, 255, 1);
    position: absolute;
    right: 0;
    top: -40px;
  }
  .couponBox {
    width: 1200px;
    padding-top: 20px;
    margin: 0 auto;
    .disable {
      color: #d1d1d1 !important;
    }
  }
  .couponBox .cardmain {
    width: 1020px;
    min-height: 200px;
    padding-top: 35px;
    margin: 0 auto;
    .tip{
      font-size: 16px;
      text-align: center;
      color: #232325;
    }
    .cardcontent {
      border-radius: 2px;
      height: 133px;
      width: 320px;
      margin-bottom: 10px;
      background: url(../../assets/assetcenter/card_normal.png) no-repeat;
      background-size: cover;
      position: relative;
      .num {
        width: 100%;
        height: 97px;
        display: flex;
        justify-content: space-between;
        .discount {
          font-size: 48px;
          margin-left: 30px;
          color: #001955;
          font-weight: bold;
          font-family: DIN-Bold;
          position: relative;
          .percent {
            font-size: 18px;
            font-family: DIN-Medium;
            font-weight: 500;
            position: absolute;
            right: -15px;
            top: 35px;
          }
          .sym {
            font-size: 18px;
            font-family: DIN-Medium;
            font-weight: 500;
            position: absolute;
            left: -15px;
            top: 10px;
          }
        }
        .rule {
          p {
            text-align: right;
            margin: 10px 20px 0 0;
            font-size: 18px;
            font-weight: 500;
            color: #232325;
          }
          p:last-child {
            font-size: 14px;
            color: #7b7b7c;
            margin-top: 0;
          }
        }
      }
      .desc {
        width: 100%;
        height: 36px;
        font-size: 14px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        p:first-child {
          margin-left: 20px;
        }
        p:last-child {
          margin-right: 20px;
        }
      }
    }
    .cardbg {
      background: url(../../assets/assetcenter/card_disable.png) no-repeat;
      background-size: cover;
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 320px;
      .bottom-l {
        p {
          color: #232325;
          span {
            color: #ff6106;
          }
          span:first-child {
            font-size: 24px;
            font-family: DIN-Medium;
            font-weight: 500;
          }
          // span:last-child {
          //   color: #7b7b7c;
          //   margin-left: 10px;
          //   text-decoration: line-through;
          // }
        }
      }
      .gray {
        color: #7b7b7c !important;
      }
      .bottom-r {
        /deep/.ivu-btn {
          width: 100px;
          height: 32px;
          color: #7b7b7c;
          border: 1px solid rgba(151, 151, 151, 1);
          border-radius: 16px;
          line-height: 30px;
        }
        .dis {
          border: 0;
        }
      }
    }
  }
  .list {
    .purple {
      color: #001955 !important;
    }
    h3 {
      font-size: 18px;
      color: #232325;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .record {
      td {
        height: 60px;
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }
      td:nth-child(2) {
        font-family: DIN-Medium;
        color: #ff6106;
      }
    }
  }
}
</style>
